import { render, staticRenderFns } from "./dept.vue?vue&type=template&id=256894a7&scoped=true&"
import script from "./dept.vue?vue&type=script&lang=js&"
export * from "./dept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256894a7",
  null
  
)

export default component.exports